// extracted by mini-css-extract-plugin
export default {"addRoleModal":"addRoleModal_addRoleModal__O201Q","labelAndInput":"addRoleModal_labelAndInput__bHbMo","label":"addRoleModal_label__PioaI","input":"addRoleModal_input__bkkY5"};